import { slices } from "@/constants/sliceNames";
import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../../axios/defaultAxios";
import { errorMessage, successMessage } from "../actions/messages.actions";

const ENDPOINT = "/apps/v2";

/****** Get Applications *******/

export const requestApplications = createAsyncThunk(
  `${slices.applications}/requestApplications`,
  async (filters = {}, { rejectWithValue, dispatch }) => {
    try {
      const response = await axios.get(`${ENDPOINT}?${new URLSearchParams(filters).toString()}`);
      return response.data.data;
    } catch (error) {
      dispatch(errorMessage(error.response?.data?.error ?? error.message));
      return rejectWithValue(error.response?.data?.error ?? error.message);
    }
  }
);

export const requestApplicationsStatus = {
  [requestApplications.fulfilled]: (state, action) => {
    const { data, records_count } = action.payload;
    state.loading = false;
    state.list = data;
    state.pageCount = records_count ?? 10;
  },
  [requestApplications.pending]: (state, action) => {
    state.loading = true;
  },
  [requestApplications.rejected]: (state, action) => {
    state.loading = false;
  },
};

/****** Delete Application *******/

export const requestDeleteApplication = createAsyncThunk(
  `${slices.applications}/requestDeleteApplication`,
  async (appId, { rejectWithValue, dispatch }) => {
    try {
      const response = await axios.delete(`${ENDPOINT}/${appId}`);
      dispatch(successMessage(response.data.message));
      return { appId };
    } catch (error) {
      dispatch(errorMessage(error.response?.data?.error ?? error.message));
      return rejectWithValue(error.response?.data?.error ?? error.message);
    }
  }
);

export const requestDeleteApplicationStatus = {
  [requestDeleteApplication.fulfilled]: (state, action) => {
    state.loading = false;
    state.list = state.list.filter((app) => app.id !== action.payload.appId);
  },
  [requestDeleteApplication.pending]: (state, action) => {
    state.loading = true;
  },
  [requestDeleteApplication.rejected]: (state, action) => {
    state.loading = false;
  },
};

/****** Fetch Single Application by Id *******/

export const requestSingleApplication = createAsyncThunk(
  `${slices.applications}/requestSingleApplication`,
  async (appId, { rejectWithValue, dispatch }) => {
    try {
      const response = await axios.get(`${ENDPOINT}/${appId}`);
      return response.data.data;
    } catch (error) {
      dispatch(errorMessage(error.response?.data?.error ?? error.message));
      return rejectWithValue(error.response?.data?.error ?? error.message);
    }
  }
);

export const requestSingleApplicationStatus = {
  [requestSingleApplication.fulfilled]: (state, action) => {
    state.loading = false;
    state.item = action.payload;
  },
  [requestSingleApplication.pending]: (state, action) => {
    state.loading = true;
  },
  [requestSingleApplication.rejected]: (state, action) => {
    state.loading = false;
    state.item = null;
  },
};

/****** Create Application *******/

export const requestCreateApplication = createAsyncThunk(
  `${slices.applications}/requestCreateApplication`,
  async ({ appData, existingApp = false }, { rejectWithValue, dispatch }) => {
    try {
      const response = await axios.post(`${ENDPOINT}${existingApp ? "/add" : ""}`, appData);
      dispatch(successMessage(response.data.message));
      return response.data.data;
    } catch (error) {
      dispatch(errorMessage(error.response?.data?.error ?? error.message));
      return rejectWithValue(error.response?.data?.error ?? error.message);
    }
  }
);

export const requestCreateApplicationStatus = {
  [requestCreateApplication.fulfilled]: (state, action) => {
    state.loading = false;
    state.item = action.payload;
  },
  [requestCreateApplication.pending]: (state, action) => {
    state.loading = true;
  },
  [requestCreateApplication.rejected]: (state, action) => {
    state.loading = false;
    state.error = action.payload;
  },
};

/****** Update Application *******/

export const requestUpdateApplication = createAsyncThunk(
  `${slices.applications}/requestUpdateApplication`,
  async ({ appId, appData }, { rejectWithValue, dispatch }) => {
    try {
      const response = await axios.put(`${ENDPOINT}/${appId}`, appData);
      dispatch(successMessage(response.data.message));
      return { data: response.data.data, appId };
    } catch (error) {
      dispatch(errorMessage(error.response?.data?.error ?? error.message));
      return rejectWithValue(error.response?.data?.error ?? error.message);
    }
  }
);

export const requestUpdateApplicationStatus = {
  [requestUpdateApplication.fulfilled]: (state, action) => {
    state.loading = false;
    const toUpdateIndex = state.list.findIndex((app) => app.id === action.payload.appId);
    if (toUpdateIndex !== -1) state.list[toUpdateIndex] = action.payload.data;
    state.item = action.payload.data;
  },
  [requestUpdateApplication.pending]: (state, action) => {
    state.loading = true;
  },
  [requestUpdateApplication.rejected]: (state, action) => {
    state.loading = false;
    state.error = action.payload;
  },
};
